import { render, staticRenderFns } from "./TemplateContent.vue?vue&type=template&id=8095202c&scoped=true&lang=pug&"
import script from "./TemplateContent.vue?vue&type=script&lang=js&"
export * from "./TemplateContent.vue?vue&type=script&lang=js&"
import style0 from "./TemplateContent.vue?vue&type=style&index=0&id=8095202c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8095202c",
  null
  
)

/* custom blocks */
import block0 from "./TemplateContent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports